import {
  ContactRoleProducerSchema as BaseContactRoleSchema,
  ContactRoleProducerSchema,
} from '@eigtech/contacts-types'
import { z } from 'zod'

export const ContactFormContactRoleEnumSchema = z.enum([
  BaseContactRoleSchema.enum.agent,
  BaseContactRoleSchema.enum.legalRepresentation,
  BaseContactRoleSchema.enum.mortgageHolder,
  BaseContactRoleSchema.enum.other,
  BaseContactRoleSchema.enum.otherContact,
  BaseContactRoleSchema.enum.policyHolder,
  BaseContactRoleSchema.enum.primaryContact,
  BaseContactRoleSchema.enum.propertyAccessContact,
  BaseContactRoleSchema.enum.qa,
  BaseContactRoleSchema.enum.thirdPartyClaimant,
])

export const ContactFormRoleFieldSchema = z.object({
  role: z.enum([...ContactRoleProducerSchema.options], {
    error: () => 'Please select a role',
  }),
})

export type ContactFormContactRole = z.infer<typeof ContactFormContactRoleEnumSchema>
export type ContactFormRoleField = z.infer<typeof ContactFormRoleFieldSchema>
